/**
 * Created by Tomasz Gabrysiak @ Infermedica on 08/02/2017.
 */

import View from '../../base/view';
import template from './template';

export default class WelcomeView extends View {
  constructor (el, context) {
    const handleCheckCondition = (e) => {
      document.getElementById('next-step').removeAttribute('disabled');
    };
    const binds = {
      '.checkCondition': {
        type: 'change',
        listener: handleCheckCondition
      }
    };
    super(el, template, context, binds);
    this.context.api.generateInterviewId();
  }
}



// WEBPACK FOOTER //
// ./src/components/welcome/view.js